import type { ReactNode } from 'react';

import GoButton from '@cartwhl/ui/input/GoButton';

import useAppletsUrl from '../../../hooks/useAppletsUrl';

interface SwingChoreoCTAProps {
  children?: ReactNode;
}

export default function SwingChoreoCTA({
  children = 'Try Swing Choreo',
}: SwingChoreoCTAProps) {
  const appletsUrl = useAppletsUrl();

  return (
    <p className="mb-8">
      <a
        href={appletsUrl && `${appletsUrl}/generation`}
        target="_blank"
        rel="noopener noreferrer"
        className="no-underline hover:no-underline"
      >
        <GoButton variant="animate" className="px-10">
          {children}
        </GoButton>
      </a>
    </p>
  );
}
